import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'a1-badge',
  styleUrl: 'a1-badge.scss',
  scoped: true,
})
export class A1Badge {
  /**
   * Text
   */
  @Prop({ reflect: true }) text: string = 'Badge Text';

  /**
   * Badge type: Default or Attention.
   */
  @Prop({ reflect: true }) type: 'default' | 'attention' = 'default';

  /**
   * Badge color.
   */
  // prettier-ignore
  @Prop({ reflect: true }) color: 'yellow' | 'orange' | 'red' | 'purple' | 'blue' | 'aqua' | 'teal' | 'green' | 'gray' | 'disabled' = 'yellow';

  private getClassMap() {
    return {
      [this.color]: 'yellow',
      [this.type]: 'default',
    };
  }

  private classNames(classes: { [key: string]: string | boolean | number }): string {
    return Object.keys(classes)
      .filter(key => !!classes[key])
      .join(' ');
  }
  render() {
    const classes = this.getClassMap();
    const classString = this.classNames(classes);

    return (
      <div class={classString} data-length={this.text?.length || 0}>
        {this.text}
      </div>
    );
  }
}
